export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const isIOS = () => {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

export const getSize = (width, original) => {
  return (width * original) / 1920;
};

export const isMobileSize = width => {
  return width < 768;
};

export const getZoom = width => {
  return isMobileSize(width) ? 1 : width > 1920 ? 1 : width / 1920;
};

export const getMobileZoom = (width, size) => {
  return isMobileSize(width) ? width / size : 1;
};
